import React, { useState, useEffect } from 'react';
import PageHeader from '../../components/PageHeader';
import aboutBg from '../../assets/AboutUs.png';
import { api } from '../../utils/api';
import './Company.css';

const fmtYear = (date) => {
  if (date === '진행중') return date;
  return date.substring(0, 4);
};

export default function Performance() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const PER_PAGE = 15;

  useEffect(() => {
    api.getPerformances()
      .then(setData)
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  }, []);

  const totalPages = Math.ceil(data.length / PER_PAGE);
  const paged = data.slice((page - 1) * PER_PAGE, page * PER_PAGE);
  const activeCount = data.filter((r) => r.contract_date === '진행중').length;

  return (
    <div>
      <PageHeader
        title="감리 실적"
        subtitle="한길에이아이가 수행한 공공기관 정보시스템 감리 실적입니다."
        bgImage={aboutBg}
      />

      <section className="page-section">
        <div className="container">

          <div className="perf-stats">
            {[
              { value: loading ? '-' : `${data.length}건`, label: '총 수행 건수' },
              { value: loading ? '-' : `${activeCount}건`, label: '진행중' },
              { value: '100%', label: '공공기관 대상' },
            ].map((s) => (
              <div key={s.label} className="perf-stat-card">
                <span className="perf-stat-value">{s.value}</span>
                <span className="perf-stat-label">{s.label}</span>
              </div>
            ))}
          </div>

          <p className="perf-note">
            ※ 모든 실적은 공공기관 발주 정보시스템 감리 사업 기준입니다. (2021년 이후 기준)
          </p>

          {loading ? (
            <p style={{ textAlign: 'center', padding: '40px 0', color: '#64748b' }}>불러오는 중...</p>
          ) : (
            <>
              <div className="perf-table-wrap">
                <table className="perf-table">
                  <colgroup>
                    <col style={{ width: '60px' }} />
                    <col />
                    <col style={{ width: '90px' }} />
                    <col style={{ width: '220px' }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>번호</th>
                      <th>사업명</th>
                      <th>계약년도</th>
                      <th>주관기관</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paged.map((row) => (
                      <tr key={row.id}>
                        <td className="perf-td-num">{row.no}</td>
                        <td className="perf-td-name">{row.name}</td>
                        <td>
                          {row.contract_date === '진행중'
                            ? <span className="perf-badge-active">진행중</span>
                            : fmtYear(row.contract_date)}
                        </td>
                        <td className="perf-td-org">{row.org}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {totalPages > 1 && (
                <div className="perf-pagination">
                  <button onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={page === 1} className="perf-page-btn">‹</button>
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
                    <button key={p} onClick={() => setPage(p)} className={`perf-page-btn ${page === p ? 'active' : ''}`}>{p}</button>
                  ))}
                  <button onClick={() => setPage((p) => Math.min(totalPages, p + 1))} disabled={page === totalPages} className="perf-page-btn">›</button>
                </div>
              )}
            </>
          )}

        </div>
      </section>
    </div>
  );
}
